
<template>
  <div>
    <section id="card-text-alignment">
      <div>
        <h5
          class="mt-3 mb-2 d-flex justify-content-start font-weight-bolder text-dark"
          style="
            font-weight: 600;
            font-size: 26px;
            font-family: 'Public Sans', sans-serif;
          "
        >
          Settings
        </h5>
      </div>
      <b-row>
        <b-col
          md="6"
          lg="4"
          class="d-flex justify-content-center align-items-center"
        >
          <b-card class="text-center settings-icon">
            <div
              class="d-flex flex-column align-items-center justify-content-center"
            >
              <div
                v-if="isLoading"
                style="height: 20px"
                class="d-flex justify-content-center align-items-center my-1"
              >
                <b-spinner label="Loading..." />
              </div>
              <h3
                v-else
                class="align-items-center font-weight-bolder my-1 count-class"
              >
                {{ data.hide_video }}
              </h3>
              <b-badge
                class="cursor-pointer title-settings"
                variant="light-primary"
                @click="openHideVideo()"
              >
                View all hide Videos
              </b-badge>
            </div>
          </b-card>
        </b-col>

        <b-col
          md="6"
          lg="4"
          class="d-flex justify-content-center align-items-center"
        >
          <b-card class="text-center settings-icon">
            <div
              class="d-flex flex-column align-items-center justify-content-center"
            >
              <h3 class="align-items-center font-weight-bolder my-1 count-class">
                Music
              </h3>
              <b-badge
                class="cursor-pointer title-settings"
                variant="light-primary"
                @click="openAudio()"
              >
                See the Audio
              </b-badge>
            </div>
          </b-card>
        </b-col>

        <b-col
          md="6"
          lg="4"
          class="d-flex justify-content-center align-items-center"
        >
          <b-card class="text-center settings-icon">
            <div
              class="d-flex flex-column align-items-center justify-content-center"
            >
              <feather-icon icon="GridIcon" size="50" />
              <div
                v-if="isLoading"
                style="height: 20px"
                class="d-flex justify-content-center align-items-center my-1"
              >
                <b-spinner label="Loading..." />
              </div>
              <h3
                v-else
                class="align-items-center font-weight-bolder my-1 count-class"
              >
                {{ data.categories }}
              </h3>
              <b-badge
                class="cursor-pointer title-settings"
                variant="light-primary"
                @click="$router.push('/settings/categories')"
              >
                Categories
              </b-badge>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </section>
  </div>
</template>

<script>
import {
  BCard,
  BBadge,
  BRow,
  BCol,
  BSpinner,
} from 'bootstrap-vue'
import axios from 'axios'

export default {
  components: {
    BBadge,
    BCard,
    BRow,
    BCol,
    BSpinner,
  },
  data() {
    return {
      accessToken: localStorage.getItem('accessToken'),
      baseApi: process.env.VUE_APP_APIENDPOINT,
      data: {
        hide_video: 0,
        categories: 0,
      },
      isLoading: false,
    }
  },
  mounted() {
    this.getCount()
  },
  methods: {
    async getCount() {
      this.isLoading = true
      try {
        const response = await axios({
          method: 'GET',
          url: `${this.baseApi}getCounts`,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.accessToken}`,
          },
        })
        const payload = response?.data?.data
        if (payload && typeof payload === 'object') {
          this.data = {
            hide_video: Number(payload.hide_video) || 0,
            categories: Number(payload.categories) || 0,
          }
        }
      } catch (error) {
        // Legacy fitness endpoint — keep zeros so the hub still renders.
        this.data = { hide_video: 0, categories: 0 }
      } finally {
        this.isLoading = false
      }
    },
    openHideVideo() {
      this.$router.push({ path: '/settings/allvideos' })
    },
    openAudio() {
      this.$router.push({ path: '/settings/audio' })
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-faq.scss";

.settings-icon {
  width: 382.67px;
  height: 260px;
  border-radius: 6px;
  border: 1px solid #dbdade;
  gap: 16px;
}

.settings-icon .card-body {
  display: flex;
  align-items: center;
  justify-content: center;
}

.title-settings {
  font-size: 15px;
}

.count-class {
  font-size: 18px;
}
</style>
